export default "__VITE_ASSET__pxySGYkd__"